@if (isVisible()) {
  <div class="fixed inset-0 bg-th-blue-modal/70 flex items-center justify-center z-50">
    <div class="flex flex-col items-center justify-center">
      <div
        class="flex flex-col items-center justify-center relative rounded-full bg-white w-45 h-45"
      >
        <div
          class="absolute w-[115%] h-[115%] rounded-full border-2 border-th-light-purple"
        ></div>

        <img src="images/seiza-favicon.svg" alt="Seiza" class="w-10 h-10 animate-[spin_1.5s_linear_infinite]" />

        <div class="mt-4">
          <p class="text-th-blue-original text-[16px] font-semibold text-center">
            {{ message() }}
          </p>
        </div>
      </div>
    </div>
  </div>
}
